module.exports = __webpack_public_path__ + "static/media/orderby.d99bf78a.svg";